/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Github_HintInputs */



/**
* | output |
* | --- |
* | "Link so we can mention you on your feedback issues" |
*
* @param {Profile_Github_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_github_hint = /** @type {((inputs?: Profile_Github_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Github_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liez pour que nous puissions vous mentionner dans vos issues de commentaires")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincula para que podamos mencionarte en tus issues de feedback")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincule para que possamos mencioná-lo nas suas issues de feedback")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega per permetterci di menzionarti nelle tue issue di feedback")
	return /** @type {LocalizedString} */ ("Link so we can mention you on your feedback issues")
});